
<h4>Vertical Rule</h4><br><br>
<div class="select-access-level">Access Level:</div>
<div class="input-type-select-access-level" [(accessLevel)]="section.accessLevel"></div><br><br>
<div class="input-title">Contents Name</div>
<textarea class="contents-entry-name" placeholder="A short name" [(ngModel)]="section.contentsName"></textarea><br><br>
<div class="select-padding-top">Padding Top</div>
<input type="text" placeholder="Enter an integer" [(ngModel)]="section.contentPaddingTop"><br>
<div class="select-padding-bottom">Padding Bottom</div>
<input type="text" placeholder="Enter an integer" [(ngModel)]="section.contentPaddingBottom"><br><br>
<div class="select-background-color">Color</div>
<div class="select-background-color-block" *ngFor="let color of app.colors;" [style.background-color]="color" (click)="section.contentBackgroundColor = color"></div><a class="reset-background active" (click)="section.contentBackgroundColor = null">Reset</a><br><br>